<template>
  <div>
    <div class="w-5 h-5 rounded-full bg-primary mr-4 relative" v-if="addpart">
      <div class="w-2 h-2 rounded-full absolute bg-white radiobox"></div>
    </div>

    <div
      class="w-5 h-5 rounded-full border border-primary mr-4"
      v-if="!addpart"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    addpart: Boolean,
  },
  data() {
    return {};
  },
};
</script>

<style>
.radiobox {
  top: 6px;
  left: 6px;
}
</style>
